import {
  CUSTOM_ELEMENTS_SCHEMA,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { DswFooterComponent } from '@vi-succ/design-system-web';

import { AuthStore, LanguageStore, SUPPORTED_LOCALES } from '@store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { viguideVersion } from '../../../../../package-version';
import { CommonStandaloneModule } from '../../common-standalone.module';

@Component({
  selector: 'vi-dsw-footer',
  standalone: true,
  imports: [CommonStandaloneModule, DswFooterComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './vi-dsw-footer.component.html',
  styleUrls: ['./vi-dsw-footer.component.scss'],
})
export class ViDswFooterComponent implements OnInit, OnDestroy {
  languageLocale: string = SUPPORTED_LOCALES.de;
  appVersion = viguideVersion;

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public authStore: AuthStore,
    private languageStore: LanguageStore,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.languageStore.languageCode$.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((language) => {
      this.languageLocale = language;
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
